import React from 'react';

// import components
import SearchResults from 'components/partials/parts/search-results';

// import helpers
import { getLinkDataFromDato } from 'helpers/get-link-data';

type SearchResultsProps = {
    matchingSearchFaqs: Queries.FaqBlockFragment[]
}

const FaqSearchResults: React.FC<SearchResultsProps> = ({ matchingSearchFaqs }) => {

    // check matchingSearchFaqs
    if (!matchingSearchFaqs || matchingSearchFaqs.length === 0) {
        return null;
    }

    const cards = matchingSearchFaqs.map((faq) => {

        let linkData = getLinkDataFromDato(faq.link?.link);

        return {
            title: faq.question || '',
            subtitle: '',
            snippet: faq.answer || '',
            url: linkData?.url || ''
        };
    });

    if (!cards || cards.length === 0) {
        return null;
    }

    return (
        <div className="pattern">
            <div className="container container--md">
                <SearchResults cards={cards} />
            </div>
        </div>
    );
};

export default FaqSearchResults;